import { createContext, useEffect, useState } from 'react'
import { Checkbox, Popover } from 'antd'
import useAuthStore from '@/stores/AuthStore'
import BubbleIM from '../Components/BubbleIM'
import { MessageBox } from 'react-chat-elements'
import { cloneDeep, objectMapper, removeFormattingChars, getNestedValue } from '@haina/utils-commons'
import { replaceTemplateString, whatsappTemplateBtnParamTypesMapped } from '@/channel/bubbleMsgUtils'

const DEI_Lgc_Mapped = {
  1: { DEI_SN: 1, DEI_DepartmentName: 'CH直销组', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  2: { DEI_SN: 2, DEI_DepartmentName: 'CH大客户组', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  7: { DEI_SN: 7, DEI_DepartmentName: '市场推广', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  8: { DEI_SN: 8, DEI_DepartmentName: '德语市场', DEI_LGC: 4, lgc_n: 'German', LANGUAGE: 'de' },
  9: { DEI_SN: 9, DEI_DepartmentName: '日语市场', DEI_LGC: 3, lgc_n: 'Japanese', LANGUAGE: 'ja' },
  10: { DEI_SN: 10, DEI_DepartmentName: '商旅市场', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  11: { DEI_SN: 11, DEI_DepartmentName: '法语市场', DEI_LGC: 5, lgc_n: 'French', LANGUAGE: 'fr' },
  12: { DEI_SN: 12, DEI_DepartmentName: '西语市场', DEI_LGC: 6, lgc_n: 'Spanish', LANGUAGE: 'es' },
  13: { DEI_SN: 13, DEI_DepartmentName: '英文在线组', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  14: { DEI_SN: 14, DEI_DepartmentName: 'Train Spread', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  15: { DEI_SN: 15, DEI_DepartmentName: 'CH产品', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  16: { DEI_SN: 16, DEI_DepartmentName: 'APP移动项目组', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  17: { DEI_SN: 17, DEI_DepartmentName: 'ChinaTravel组(精华线路使用)', DEI_LGC: 104, lgc_n: 'English(CT)', LANGUAGE: 'en' },
  18: { DEI_SN: 18, DEI_DepartmentName: 'CT市场', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  19: { DEI_SN: 19, DEI_DepartmentName: '（待删除）', DEI_LGC: 1, lgc_n: 'English', LANGUAGE: 'en' },
  20: { DEI_SN: 20, DEI_DepartmentName: '俄语市场', DEI_LGC: 7, lgc_n: 'Russian', LANGUAGE: 'ru' },
  21: { DEI_SN: 21, DEI_DepartmentName: '意语市场', DEI_LGC: 8, lgc_n: 'Italian', LANGUAGE: 'it' },
  22: { DEI_SN: 22, DEI_DepartmentName: '爱游网', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  23: { DEI_SN: 23, DEI_DepartmentName: '三峡站(YZ)', DEI_LGC: 102, lgc_n: 'English(YZ)', LANGUAGE: 'en' },
  24: { DEI_SN: 24, DEI_DepartmentName: '桂林站(GL)', DEI_LGC: 103, lgc_n: 'English(GL)', LANGUAGE: 'en' },
  25: { DEI_SN: 25, DEI_DepartmentName: '上海站(SHT)', DEI_LGC: 107, lgc_n: 'English(SH)', LANGUAGE: 'en' },
  26: { DEI_SN: 26, DEI_DepartmentName: '北京站(MBJ)', DEI_LGC: 106, lgc_n: 'English(BJ)', LANGUAGE: 'en' },
  27: { DEI_SN: 27, DEI_DepartmentName: '西藏站(TBT)', DEI_LGC: 105, lgc_n: 'English(TBT)', LANGUAGE: 'en' },
  28: { DEI_SN: 28, DEI_DepartmentName: 'HT项目组(前AH)', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  29: { DEI_SN: 29, DEI_DepartmentName: 'DMC地接组', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  30: { DEI_SN: 30, DEI_DepartmentName: 'Trippest项目组', DEI_LGC: 0, lgc_n: 'English', LANGUAGE: 'en' },
  31: { DEI_SN: 31, DEI_DepartmentName: '花梨鹰', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  32: { DEI_SN: 32, DEI_DepartmentName: 'Daytours板块(Trippest)', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  33: { DEI_SN: 33, DEI_DepartmentName: 'GH项目组', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  34: { DEI_SN: 34, DEI_DepartmentName: 'trippest网站', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
  35: { DEI_SN: 35, DEI_DepartmentName: 'newsletter营销', DEI_LGC: null, lgc_n: 'English', LANGUAGE: 'en' },
}

const DEI_Template_mapped = {
  // GH: agent_intro_with_update_v1
  en: {
    name: 'agent_intro_with_update_v1',
    language: { code: 'en' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
          {
            type: 'text',
            text: 'We got your inquiry. I\'ve just sent you an email about your trip. Would you see if you\'ve received it or not? (It might be in your "filtered" mail box.)If you have not received it or have any other questions, do not hesitate to ask me.',
          },
          { type: 'text', text: 'yoyo' },
        ],
        text: "Hi {{customer_name}}, this is {{your_name1}} , your trip advisor. \nHere's a quick update for you: {{quick_detail}}\nKindest regards, {{your_name2}}. ",
      },
    ],
  },
  // email_sent_confirm_ru_v1
  ru: {
    name: 'email_sent_confirm_ru_v1',
    language: { code: 'ru' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: 'Добрый день, {{customer_name}}! Это {{your_name}}, ваш консультант . Ваш запрос по поводу поездки принята. Я отправила предложение по туру вам на почту, посмотрите, пожалуйста. Благодарю!',
      },
    ],
  },
  // inquiry_confirm_v1
  fr: {
    name: 'inquiry_confirm_v1',
    language: { code: 'fr' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: 'Bonjour {{customer_name}},C’est {{your_name}}, votre conseillère de voyage chez {{agency_name}}. Votre demande de voyage est bien traitée. Je viens de vous envoyer la proposition de prix par email, merci de bien vouloir vérifier votre boîte mail.',
      },
    ],
  },
  // inquiry_confirm_ja_v4
  ja: {
    name: 'inquiry_confirm_ja_v4',
    language: { code: 'ja' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: 'いつもお世話になっております。{{customer_name}} 様、こちら {{your_name}} でございます。ご旅行のご相談を承りました。先ほどメールにて旅程のご提案を送付いたしましたので、ご確認いただけますようお願いいたします。よろしくお願いいたします。',
      },
    ],
  },
  // inquiry_confirm_it_v1
  it: {
    name: 'inquiry_confirm_it_v1',
    language: { code: 'it' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: "Buongiorno, {{customer_name}}, sono  {{your_name}} da China Highlights, grazie per l'interesse verso il nostro servizio, la Sua richiesta di consulenza di viaggio è stata presa in carico. Le ho appena inviato una proposta di itinerario via email, la invito a controllare la sua casella di posta. Grazie.",
      },
    ],
  },
  // email_sent_confirm_es_v4
  es: {
    name: 'email_sent_confirm_es_v4',
    language: { code: 'es' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: 'Hola，{{customer_name}}，soy su asesora de viaje {{your_name}}，hemos recibido su consulta sobre el viaje. Acabo de mandarle un correo sobre el itinerario, por favor, revise su correo, muchas gracias! ',
      },
    ],
  },
  // inquiry_confirm_v1
  de: {
    name: 'inquiry_confirm_v1',
    language: { code: 'de' },
    components: [
      {
        type: 'body',
        parameters: [
          { type: 'text', text: 'test OT 22' },
          { type: 'text', text: 'yoyo' },
        ],
        text: 'Hallo {{customer_name}}, Ihre Anfrage wurde bearbeitet und Sie haben eine erste E-Mail erhalten. Bitte bestätigen Sie den Erhalt. Vielen Dank.',
      },
    ],
  },
}

const DEFAULT_FILL = {
  agent_intro_with_update_v1: {
    quick_detail:
      'We got your inquiry. I\'ve just sent you an email about your trip. Would you see if you\'ve received it or not? (It might be in your "filtered" mail box). If you have not received it or have any other questions, do not hesitate to ask me.',
  },
  inquiry_confirm_v1: {
    agency_name: 'China Highlights',
  },
}

const AutoSendWAForEmail = ({ disabled, orderDetail, onChange, ...props }) => {
  const [loginUser] = useAuthStore((state) => [state.loginUser])
  loginUser.usernameEN = (loginUser.accountList[0]?.OPI_NameEN || '').split(' ')?.[0] || loginUser.username;
  const dei = loginUser.accountList[0].OPI_DEI_SN
  const dei_mapped = DEI_Template_mapped[DEI_Lgc_Mapped[dei].LANGUAGE || 'en']
  const keys = (dei_mapped.components[0].text.match(/{{(.*?)}}/g) || []).map((key) => key.replace(/{{|}}/g, ''))

  const valueMapped = {
    ...cloneDeep(orderDetail),
    ...objectMapper(loginUser, { username: [{ key: 'agent_name' }, { key: 'your_name' }, { key: 'your_name1' }, { key: 'your_name2' }] }),
    ...objectMapper(loginUser, { usernameEN: [{ key: 'agent_name' }, { key: 'your_name' }, { key: 'your_name1' }, { key: 'your_name2' }] }),
    ...{ order_number: orderDetail.order_no, customer_name: orderDetail?.customerDetail?.name },
    ...DEFAULT_FILL[dei_mapped.name],
  }
  const paramsVal = keys.reduce((r, k) => ({ ...r, [k]: getNestedValue(valueMapped, [k]) }), {})
  const params = keys.map((v) => ({ type: 'text', text: getNestedValue(paramsVal, [v]) }))
  const paramText = keys.length ? params.map((p) => p.text) : []
  const fillTemplate = paramText.length ? replaceTemplateString(dei_mapped.components[0].text || '', paramText) : citem?.text || ''

  const [openTemplates, setOpenTemplates] = useState(false);
  const handleSendChange = ({ target: { checked } }) => {
    const _template = cloneDeep(dei_mapped)
    _template.components[0].parameters = params
    _template.components[0].text = fillTemplate
    if (typeof onChange === 'function') {
      onChange(checked !== true ? null : _template)
    }
  }

  return (
    <>
      <Popover
        fresh
        forceRender
        placement='bottomRight'
        classNames={{ root: 'w-3/5' }}
        open={openTemplates}
        onOpenChange={(v) => {
          if ( ! disabled) setOpenTemplates(v);
        }}
        content={
          <MessageBox
            notch={false}
            type='text'
            position='right'
            text={fillTemplate}
            className={[
              'whitespace-pre-wrap mb-2',
              `[&_.rce-mbox]:bg-waba-me`,
            ].join(' ')}
          />
        }>
        <Checkbox disabled={disabled} onChange={handleSendChange}>同时发送WhatsApp</Checkbox>
      </Popover>
    </>
  )
}
export default AutoSendWAForEmail
